export default __webpack_public_path__ + "static/media/icon-rupture.09bbe9ad.svg";